import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { CurrentProductService } from "@spartacus/storefront";
import { Product } from '@spartacus/core';

@Component({
    selector: 'gen-product-notes',
    templateUrl: './product-notes.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenProductNotesComponent {
  product$: Observable<Product | null>;

  constructor(
    protected currentProductService: CurrentProductService,
  ) {
    this.product$ = this.currentProductService.getProduct();
  }
}
